'use memo';

import type { ListContractAlertsQuery } from '@standandforce/api-contract';
import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/lib/api/orpc';
import { QUERY_PRESETS } from '@/lib/query';
export type { ContractAlertItem, ListContractAlertsQuery } from '@standandforce/api-contract';
export function useContractAlerts(params: ListContractAlertsQuery) {
  return useQuery({
    ...orpc.contractAlert.list.queryOptions({
      input: params
    }),
    ...QUERY_PRESETS.list()
  });
}
export function useContractAlertCount() {
  return useQuery({
    ...orpc.contractAlert.count.queryOptions({}),
    ...QUERY_PRESETS.list()
  });
}